import { API_ENDPOINTS } from 'services/api';
import httpClient from 'services/httpClient';
import {
  CurriculumMappingParams,
  CurriculumMappingResponse
} from '../../types/dacum/curriculumMapping';

export const curriculumMappingService = {
  getCurriculumMapping: async (
    params: CurriculumMappingParams
  ): Promise<CurriculumMappingResponse> => {
    const response = await httpClient.get<CurriculumMappingResponse>(
      API_ENDPOINTS.DACUM.CURRICULUM_MAPPING.LIST,
      {
        params
      }
    );
    return response.data;
  }
};
